(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const form = document.querySelector('.cart-page__form');
    if (!form) return;

    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-page-qty]');
      if (!button || !form.contains(button)) return;

      const qty = button.closest('.cart-page__qty');
      const input = qty?.querySelector('.cart-page__qty-value');
      if (!input) return;

      const current = Number(input.value) || 0;
      const next =
        button.dataset.qtyAction === 'increase' ? current + 1 : Math.max(0, current - 1);

      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const success = document.getElementById('FooterNewsletter-success');
    if (!success) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    requestAnimationFrame(() => {
      success.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'center',
      });
      success.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preview-select-sounds"] && !Shopify.designMode) return;
  try {
    
  (() => {
    window.addEventListener('message', (event) => {
      if (event.data?.type !== 'AUDIOPREVIEWER_IFRAME_SCROLL') return;
      window.scrollBy(event.data.deltaX || 0, event.data.deltaY || 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const REVIEWS_HASH = '#judgeme_product_reviews';

    const sectionHtmlFromPayload = (payload, sectionId) => {
      if (!payload || typeof payload !== 'object') return null;
      const sections = payload.sections || payload;
      return sections[sectionId] || null;
    };

    const reinitJudgeMe = () => {
      try {
        if (typeof window.jdgm?.initializeWidgets === 'function') {
          window.jdgm.initializeWidgets();
        } else if (typeof window.jdgm_preloader === 'function') {
          window.jdgm_preloader();
        }
      } catch (_) {
        /* Judge.me optional */
      }
    };

    const removePendingSection = (pendingRoot) => {
      const sectionEl = pendingRoot.closest('.shopify-section');
      if (sectionEl) sectionEl.remove();
      else pendingRoot.remove();
    };

    const hydrateDeferred = (pendingRoot) => {
      if (!pendingRoot) return Promise.resolve(false);
      if (pendingRoot.dataset.reviewsReady === 'true') return Promise.resolve(true);
      if (pendingRoot._reviewsHydratePromise) return pendingRoot._reviewsHydratePromise;

      pendingRoot.dataset.reviewsLoading = 'true';
      pendingRoot._reviewsHydratePromise = (async () => {
        const sectionId = pendingRoot.dataset.sectionId;
        if (!sectionId) {
          removePendingSection(pendingRoot);
          return false;
        }

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', sectionId);
          const response = await fetch(url.pathname + url.search);
          if (!response.ok) throw new Error('Product reviews section failed');

          const data = await response.json();
          const html = sectionHtmlFromPayload(data, sectionId);
          if (!html) {
            removePendingSection(pendingRoot);
            return false;
          }

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newSection =
            doc.querySelector(`#shopify-section-${CSS.escape(sectionId)}`) ||
            doc.body.firstElementChild;
          const reviewsRoot = newSection?.querySelector('[data-product-reviews]');

          if (!newSection || !reviewsRoot) {
            removePendingSection(pendingRoot);
            return false;
          }

          const currentSection = pendingRoot.closest('.shopify-section');
          if (currentSection) currentSection.replaceWith(newSection);
          else pendingRoot.replaceWith(newSection);

          reviewsRoot.dataset.reviewsReady = 'true';
          requestAnimationFrame(() => {
            reinitJudgeMe();
            window.setTimeout(reinitJudgeMe, 350);
          });
          return true;
        } catch (_) {
          removePendingSection(pendingRoot);
          return false;
        }
      })();

      return pendingRoot._reviewsHydratePromise;
    };

    const observeDeferred = (pendingRoot) => {
      if (!pendingRoot) return;

      if (!('IntersectionObserver' in window)) {
        hydrateDeferred(pendingRoot);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          hydrateDeferred(pendingRoot);
        },
        { rootMargin: '400px 0px', threshold: 0.01 }
      );

      observer.observe(pendingRoot);
    };

    const scrollToReviews = () => {
      document.getElementById('judgeme_product_reviews')?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth',
        block: 'start',
      });
    };

    document.querySelectorAll('[data-product-reviews-defer]').forEach(observeDeferred);

    if (window.location.hash === REVIEWS_HASH) {
      const pending = document.querySelector('[data-product-reviews-defer]');
      if (pending) {
        hydrateDeferred(pending).then((ok) => {
          if (ok) scrollToReviews();
        });
      }
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest(`a[href="${REVIEWS_HASH}"]`);
      if (!link) return;

      const pending = document.querySelector('[data-product-reviews-defer]');
      if (!pending) return;

      event.preventDefault();
      hydrateDeferred(pending).then((ok) => {
        if (ok) {
          history.replaceState(null, '', REVIEWS_HASH);
          scrollToReviews();
        }
      });
    });

    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target;
      if (!(container instanceof Element)) return;
      container.querySelectorAll('[data-product-reviews-defer]').forEach(observeDeferred);
      if (container.querySelector('[data-product-reviews]')) {
        requestAnimationFrame(() => {
          reinitJudgeMe();
          window.setTimeout(reinitJudgeMe, 350);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealLoadedImage = (img) => {
    if (!(img instanceof HTMLImageElement)) return;

    const markLoaded = () => {
      img.classList.add('is-loaded');
    };

    if (img.complete && img.naturalWidth > 0) {
      markLoaded();
      return;
    }

    img.addEventListener('load', markLoaded, { once: true });
    img.addEventListener('error', markLoaded, { once: true });
  };

  const initProductImageFades = (section) => {
    if (prefersReducedMotion()) return;

    section.classList.add('product-page--enhanced');

    /* Main gallery images stay visible for LCP; only thumbs need load fades. */
    const images = section.querySelectorAll(
      '.product-page__thumb img, .product-page__variant-thumb img'
    );
    images.forEach(revealLoadedImage);
  };

  const initProductPage = (section) => {
    if (section.dataset.productPageReady === 'true') return;
    const productJson = section.querySelector('[data-product-json]');
    if (!productJson) return;

    let product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch {
      return;
    }

    section.dataset.productPageReady = 'true';

    initProductImageFades(section);

    const variantInput = section.querySelector('[data-variant-input]');
    const priceEl = section.querySelector('[data-price]');
    const compareEl = section.querySelector('[data-compare-price]');
    const saveEl = section.querySelector('[data-save-badge]');
    const addToCartBtn = section.querySelector('[data-add-to-cart]');
    const productForm = section.querySelector('[data-product-form]');
    const stickyAtc = section.querySelector('[data-sticky-atc]');
    const stickyAtcButton = section.querySelector('[data-sticky-atc-button]');
    const stickyAtcPrice = section.querySelector('[data-sticky-atc-price]');
    const stickyAtcCompare = section.querySelector('[data-sticky-atc-compare]');
    const variantButtons = section.querySelectorAll('[data-variant-id]');
    const mediaItems = section.querySelectorAll('[data-main-media] [data-media-id]');
    const thumbButtons = section.querySelectorAll('[data-thumb-index]');
    const moneyFormat = section.dataset.moneyFormat || '';
    const addToCartLabel = section.dataset.addToCartLabel || 'ADD TO CART';
    const soldOutLabel = section.dataset.soldOutLabel || 'SOLD OUT';
    const stickyAtcMq = window.matchMedia('(max-width: 989px)');
    let buyRowOutOfView = false;

    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return (cents / 100).toFixed(2);
    };

    const setActiveMedia = (mediaId) => {
      if (!mediaId) return;
      let matched = false;

      mediaItems.forEach((item) => {
        const isMatch = String(item.dataset.mediaId) === String(mediaId);
        item.hidden = !isMatch;
        item.classList.toggle('is-active', isMatch);
        if (isMatch) matched = true;
      });

      thumbButtons.forEach((button) => {
        const isMatch = String(button.dataset.mediaId) === String(mediaId);
        button.classList.toggle('is-active', isMatch);
        button.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });

      if (!matched && mediaItems.length) {
        mediaItems[0].hidden = false;
        mediaItems[0].classList.add('is-active');
      }
    };

    const updateVariant = (variantId) => {
      const variant = product.variants.find((item) => item.id === Number(variantId));
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;

      variantButtons.forEach((button) => {
        const isActive = Number(button.dataset.variantId) === variant.id;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (compareEl) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.classList.toggle('is-hidden', !onSale);
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }

      if (saveEl) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (onSale) {
          const savePercent = Math.round(
            ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
          );
          saveEl.textContent = `Save ${savePercent}%`;
          saveEl.classList.remove('is-hidden');
        } else {
          saveEl.classList.add('is-hidden');
          saveEl.textContent = '';
        }
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? addToCartLabel : soldOutLabel;
      }

      if (stickyAtcButton) {
        stickyAtcButton.disabled = !variant.available;
        stickyAtcButton.textContent = variant.available ? addToCartLabel : soldOutLabel;
      }

      if (stickyAtcPrice) stickyAtcPrice.textContent = formatMoney(variant.price);

      if (stickyAtcCompare) {
        const onSaleSticky = variant.compare_at_price && variant.compare_at_price > variant.price;
        stickyAtcCompare.classList.toggle('is-hidden', !onSaleSticky);
        stickyAtcCompare.textContent = onSaleSticky ? formatMoney(variant.compare_at_price) : '';
      }

      const preview = section.querySelector('[data-cart-preview]');
      if (preview) {
        preview.dataset.variantId = String(variant.id);
        preview.dataset.productPrice = String(variant.price);
        preview.dataset.productComparePrice = String(variant.compare_at_price || variant.price);
        const imageSrc =
          variant.featured_image?.src ||
          variant.featured_media?.preview_image?.src ||
          product.featured_image ||
          '';
        if (imageSrc) {
          const sized = imageSrc.includes('?') ? `${imageSrc}&width=240` : `${imageSrc}?width=240`;
          preview.dataset.productImage = sized;
        }
      }

      const activeVariantButton = section.querySelector(`[data-variant-id="${variant.id}"]`);
      const mediaId = activeVariantButton?.dataset.variantMediaId || variant.featured_media?.id;
      if (mediaId) setActiveMedia(mediaId);
    };

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => updateVariant(button.dataset.variantId));
    });

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const mediaId = button.dataset.mediaId;
        setActiveMedia(mediaId);
      });
    });

    const buyRow = section.querySelector('.product-page__buy-row');
    let lastSyncedBuyHeight = 0;
    let observedShopButton = null;
    let shopButtonResizeObserver = null;

    const getShopPayButton = () => {
      if (!buyRow) return null;
      return (
        buyRow.querySelector('shop-pay-wallet-button') ||
        buyRow.querySelector('.shopify-payment-button__button') ||
        buyRow.querySelector('.shopify-payment-button__button--unbranded') ||
        buyRow.querySelector('.shopify-payment-button__button--branded') ||
        buyRow.querySelector('.shopify-payment-button button')
      );
    };

    const syncBuyButtonHeights = () => {
      if (!buyRow || !addToCartBtn) return;

      const shopButton = getShopPayButton();
      if (!shopButton) return;

      const shopHeight = Math.round(shopButton.getBoundingClientRect().height);
      if (!shopHeight || shopHeight === lastSyncedBuyHeight) return;

      lastSyncedBuyHeight = shopHeight;
      /* Only size ATC to the real wallet/payment button — never write back
         into Shop Pay sizing (avoids feedback loops / inflated wrappers). */
      buyRow.style.setProperty('--buy-btn-height', `${shopHeight}px`);
    };

    const observeShopPayButton = () => {
      const shopButton = getShopPayButton();
      if (!shopButton || shopButton === observedShopButton) {
        syncBuyButtonHeights();
        return;
      }

      if (shopButtonResizeObserver) shopButtonResizeObserver.disconnect();
      observedShopButton = shopButton;
      shopButtonResizeObserver = new ResizeObserver(() => syncBuyButtonHeights());
      shopButtonResizeObserver.observe(shopButton);
      syncBuyButtonHeights();
    };

    observeShopPayButton();
    window.addEventListener('load', observeShopPayButton);
    window.addEventListener('resize', () => {
      lastSyncedBuyHeight = 0;
      syncBuyButtonHeights();
    });

    if (buyRow) {
      /* Watch for Shop Pay widget mounting — childList only, never attributes. */
      const shopMountObserver = new MutationObserver(() => observeShopPayButton());
      shopMountObserver.observe(buyRow, { childList: true, subtree: true });
      window.setTimeout(observeShopPayButton, 250);
      window.setTimeout(observeShopPayButton, 1000);
    }

    const clearStickyAtcOffset = () => {
      document.documentElement.removeAttribute('data-sticky-atc-visible');
      document.documentElement.style.setProperty('--pfs-sticky-atc-offset', '0px');
    };

    let lastStickyAtcOffset = -1;
    const publishStickyAtcOffset = () => {
      if (!stickyAtc || stickyAtc.hidden) {
        if (lastStickyAtcOffset !== 0) {
          lastStickyAtcOffset = 0;
          clearStickyAtcOffset();
        }
        return;
      }

      const height = Math.round(stickyAtc.getBoundingClientRect().height);
      if (height === lastStickyAtcOffset) return;

      lastStickyAtcOffset = height;
      document.documentElement.setAttribute('data-sticky-atc-visible', '');
      document.documentElement.style.setProperty('--pfs-sticky-atc-offset', `${height}px`);
    };

    const updateStickyAtcVisibility = () => {
      if (!stickyAtc) return;

      const shouldShow = stickyAtcMq.matches && buyRowOutOfView;
      stickyAtc.hidden = !shouldShow;

      if (!shouldShow) {
        lastStickyAtcOffset = 0;
        clearStickyAtcOffset();
        return;
      }

      requestAnimationFrame(publishStickyAtcOffset);
    };

    if (stickyAtc) {
      const sectionEl = section.closest('.shopify-section') || section;
      const stickyHost = sectionEl.id || `sticky-atc-${Date.now()}`;

      document
        .querySelectorAll(`[data-sticky-atc-host="${stickyHost}"]`)
        .forEach((el) => {
          if (el !== stickyAtc) el.remove();
        });

      stickyAtc.dataset.stickyAtcHost = stickyHost;
      document.body.appendChild(stickyAtc);

      stickyAtcButton?.addEventListener('click', () => {
        if (!productForm || stickyAtcButton.disabled) return;
        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit();
          return;
        }
        productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });

      if (buyRow) {
        const stickyAtcObserver = new IntersectionObserver(
          ([entry]) => {
            buyRowOutOfView = !entry.isIntersecting;
            updateStickyAtcVisibility();
          },
          { threshold: 0, rootMargin: '0px 0px -1px 0px' }
        );
        stickyAtcObserver.observe(buyRow);

        const stickyAtcResize = new ResizeObserver(() => {
          if (!stickyAtc.hidden) publishStickyAtcOffset();
        });
        stickyAtcResize.observe(stickyAtc);

        const onStickyAtcMqChange = () => updateStickyAtcVisibility();
        if (typeof stickyAtcMq.addEventListener === 'function') {
          stickyAtcMq.addEventListener('change', onStickyAtcMqChange);
        } else if (typeof stickyAtcMq.addListener === 'function') {
          stickyAtcMq.addListener(onStickyAtcMqChange);
        }

        const cleanupStickyAtc = () => {
          stickyAtcObserver.disconnect();
          stickyAtcResize.disconnect();
          stickyAtc.remove();
          clearStickyAtcOffset();
        };

        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target === sectionEl) cleanupStickyAtc();
        });
      }

      updateStickyAtcVisibility();
    }
  };

  const parseCssColor = (value) => {
    const raw = (value || '').trim();
    if (!raw) return null;

    if (raw.startsWith('#')) {
      let hex = raw.slice(1);
      if (hex.length === 3) {
        hex = hex.split('').map((char) => char + char).join('');
      }
      if (hex.length !== 6) return null;
      return {
        r: Number.parseInt(hex.slice(0, 2), 16),
        g: Number.parseInt(hex.slice(2, 4), 16),
        b: Number.parseInt(hex.slice(4, 6), 16),
        a: 1,
      };
    }

    const rgbMatch = raw.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*([\d.]+))?\s*\)/i);
    if (rgbMatch) {
      return {
        r: Number.parseFloat(rgbMatch[1]),
        g: Number.parseFloat(rgbMatch[2]),
        b: Number.parseFloat(rgbMatch[3]),
        a: rgbMatch[4] != null ? Number.parseFloat(rgbMatch[4]) : 1,
      };
    }

    return null;
  };

  const applyBstThemeStyles = () => {
    const cfg = window.bstfbt_metafieldsConfiguration;
    if (!cfg?.settings?.styles || cfg.__pfsThemed) return false;

    const rootStyles = getComputedStyle(document.documentElement);
    const accent = parseCssColor(rootStyles.getPropertyValue('--color-accent')) || { r: 255, g: 90, b: 42, a: 1 };
    const foreground = parseCssColor(rootStyles.getPropertyValue('--color-foreground')) || { r: 255, g: 255, b: 255, a: 1 };
    const muted = parseCssColor(rootStyles.getPropertyValue('--color-muted')) || { r: 138, g: 138, b: 138, a: 1 };
    const surface = parseCssColor(rootStyles.getPropertyValue('--color-surface')) || { r: 23, g: 23, b: 23, a: 1 };
    const border = { ...foreground, a: 0.12 };

    const styles = cfg.settings.styles;
    styles.widget = styles.widget || {};
    styles.widget.backgroundColor = { ...surface, a: 1 };
    styles.widget.border = { color: border, style: 'none', width: 0, radius: 12 };
    styles.widget.padding = { top: 0, left: 0, right: 0, bottom: 0 };
    styles.widget.alignment = 'left';
    styles.widget.forceSmallLayout = true;
    styles.widget.smallLayoutAlignment = 'left';

    styles.heading = Object.assign({}, styles.heading, {
      bold: true,
      color: foreground,
      fontSize: 16,
      italic: false,
      underline: false,
    });
    styles.subheading = Object.assign({}, styles.subheading, {
      bold: false,
      color: muted,
      fontSize: 13,
      italic: false,
      underline: false,
    });

    styles.cta = styles.cta || {};
    styles.cta.backgroundColor = accent;
    styles.cta.radius = 999;
    styles.cta.border = { color: accent, width: 0 };
    styles.cta.title = Object.assign({}, styles.cta.title, {
      bold: true,
      color: { r: 15, g: 15, b: 15, a: 1 },
      fontSize: 14,
      italic: false,
      underline: false,
    });

    styles.products = styles.products || {};
    styles.products.title = Object.assign({}, styles.products.title, {
      bold: true,
      color: foreground,
      fontSize: 13,
    });
    styles.products.price = Object.assign({}, styles.products.price, {
      bold: true,
      color: accent,
      fontSize: 13,
    });
    styles.products.comparedAtPrice = Object.assign({}, styles.products.comparedAtPrice, {
      bold: false,
      color: muted,
      fontSize: 12,
      visibility: 'visible',
    });
    styles.products.checkbox = Object.assign({}, styles.products.checkbox, {
      backgroundColor: accent,
    });
    styles.products.variantSelector = Object.assign({}, styles.products.variantSelector, {
      border: { color: border, style: 'solid', width: 1, radius: 8 },
      padding: { top: 6, left: 8, right: 8, bottom: 6 },
    });

    styles.totalPrice = styles.totalPrice || {};
    styles.totalPrice.label = Object.assign({}, styles.totalPrice.label, {
      bold: true,
      color: foreground,
      fontSize: 14,
    });
    styles.totalPrice.price = Object.assign({}, styles.totalPrice.price, {
      bold: true,
      color: accent,
      fontSize: 16,
    });
    styles.totalPrice.comparedAtPrice = Object.assign({}, styles.totalPrice.comparedAtPrice, {
      bold: false,
      color: muted,
      fontSize: 13,
    });
    styles.totalPrice.isContainerVisible = true;

    styles.productImage = styles.productImage || {};
    styles.productImage.border = { color: border, style: 'solid', width: 1, radius: 8 };
    styles.productImage.separatorColor = border;
    styles.productImage.width = { largeLayout: 64, smallLayout: 56 };

    styles.soldOutBadge = styles.soldOutBadge || {};
    styles.soldOutBadge.backgroundColor = accent;
    styles.soldOutBadge.label = Object.assign({}, styles.soldOutBadge.label, {
      color: { r: 15, g: 15, b: 15, a: 1 },
    });

    if (cfg.settings.texts?.default) {
      cfg.settings.texts.default.widgetHeading =
        cfg.settings.texts.default.widgetHeading || 'Frequently Bought Together';
    }

    cfg.settings.showWatermark = false;
    cfg.__pfsThemed = true;
    return true;
  };

  const watchBstTheme = () => {
    if (applyBstThemeStyles()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (applyBstThemeStyles() || attempts > 80) {
        window.clearInterval(timer);
      }
    }, 50);

    const originalDescriptor = Object.getOwnPropertyDescriptor(window, 'bstfbt_metafieldsConfiguration');
    if (!originalDescriptor || originalDescriptor.configurable) {
      let stored = window.bstfbt_metafieldsConfiguration;
      Object.defineProperty(window, 'bstfbt_metafieldsConfiguration', {
        configurable: true,
        enumerable: true,
        get() {
          return stored;
        },
        set(value) {
          stored = value;
          applyBstThemeStyles();
        },
      });
      if (stored) applyBstThemeStyles();
    }
  };

  const bstHasRenderableContent = (root) => {
    if (!(root instanceof HTMLElement)) return false;
    return Boolean(
      root.querySelector(
        [
          '.bstfbt__product-selector',
          '.bstfbt__cta',
          '.bstfbt__heading',
          '.bstfbt__product-thumbnail',
          '[class*="product-selector"]',
          '[class*="ProductSelector"]',
          'button',
          'img',
        ].join(', ')
      )
    );
  };

  const syncBstFeaturesVisibility = () => {
    document.querySelectorAll('.product-page__features').forEach((features) => {
      const hasVisibleChild = Array.from(features.children).some((child) => {
        if (!(child instanceof HTMLElement) || child.hidden) return false;
        if (child.classList.contains('product-page__bought-together')) {
          return child.classList.contains('is-ready');
        }
        return true;
      });
      features.hidden = !hasVisibleChild;
    });
  };

  const watchBstMounts = () => {
    const mounts = document.querySelectorAll('[data-bst-styled]');
    if (!mounts.length) return;

    mounts.forEach((mount) => {
      if (!(mount instanceof HTMLElement)) return;

      const markReady = () => {
        mount.classList.add('is-ready');
        mount.hidden = false;
        syncBstFeaturesVisibility();
      };

      if (bstHasRenderableContent(mount)) {
        markReady();
        return;
      }

      const observer = new MutationObserver(() => {
        if (!bstHasRenderableContent(mount)) return;
        observer.disconnect();
        markReady();
      });
      observer.observe(mount, { childList: true, subtree: true });

      window.setTimeout(() => {
        observer.disconnect();
        if (bstHasRenderableContent(mount)) {
          markReady();
          return;
        }
        mount.classList.remove('is-ready');
        mount.hidden = true;
        syncBstFeaturesVisibility();
      }, 7000);
    });

    syncBstFeaturesVisibility();
  };

  document.querySelectorAll('[data-product-page]').forEach(initProductPage);
  if (document.querySelector('[data-bst-styled]')) {
    watchBstTheme();
    watchBstMounts();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCarousel = (root) => {
      if (!root || root.dataset.carouselReady === 'true') return;
      root.dataset.carouselReady = 'true';

      const viewport = root.querySelector('[data-viewport]');
      const track = root.querySelector('[data-track]');
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      const dotsWrap = root.querySelector('[data-dots]');
      const slides = [...root.querySelectorAll('[data-slide]')];
      if (!viewport || !track || slides.length === 0) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const slideStep = () => {
        const first = slides[0];
        if (!first) return viewport.clientWidth;
        const style = getComputedStyle(track);
        const gap = Number.parseFloat(style.columnGap || style.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      };

      const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);

      const activeIndex = () => {
        const step = slideStep();
        if (step <= 0) return 0;
        return Math.round(viewport.scrollLeft / step);
      };

      const updateControls = () => {
        const max = maxScroll();
        const canScroll = max > 2;
        const atStart = viewport.scrollLeft <= 4;
        const atEnd = viewport.scrollLeft >= max - 4;

        if (prev) {
          prev.hidden = !canScroll || atStart;
          prev.disabled = prev.hidden;
        }
        if (next) {
          next.hidden = !canScroll || atEnd;
          next.disabled = next.hidden;
        }

        if (dotsWrap) {
          const showDots = canScroll && slides.length > 1;
          dotsWrap.hidden = !showDots;
          if (showDots) {
            const index = Math.min(slides.length - 1, Math.max(0, activeIndex()));
            dotsWrap.querySelectorAll('[data-dot]').forEach((dot, i) => {
              const on = i === index;
              dot.classList.toggle('is-active', on);
              dot.setAttribute('aria-current', on ? 'true' : 'false');
            });
          }
        }
      };

      const scrollToIndex = (index) => {
        const clamped = Math.max(0, Math.min(slides.length - 1, index));
        viewport.scrollTo({
          left: clamped * slideStep(),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      };

      if (dotsWrap && slides.length > 1) {
        dotsWrap.replaceChildren(
          ...slides.map((_, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'related-products__dot';
            btn.dataset.dot = String(i);
            btn.setAttribute('aria-label', `Go to product ${i + 1}`);
            btn.addEventListener('click', () => scrollToIndex(i));
            return btn;
          })
        );
      }

      prev?.addEventListener('click', () => scrollToIndex(activeIndex() - 1));
      next?.addEventListener('click', () => scrollToIndex(activeIndex() + 1));

      viewport.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateControls);
      }, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(() => updateControls()).observe(viewport);
      } else {
        window.addEventListener('resize', updateControls);
      }

      updateControls();
      window.requestAnimationFrame(updateControls);
      window.addEventListener('load', updateControls, { once: true });
    };

    const sectionHtmlFromPayload = (payload, sectionId) => {
      if (!payload || typeof payload !== 'object') return null;
      const sections = payload.sections || payload;
      return sections[sectionId] || null;
    };

    const removePendingSection = (pendingRoot) => {
      const sectionEl = pendingRoot.closest('.shopify-section');
      if (sectionEl) sectionEl.remove();
      else pendingRoot.remove();
    };

    const hydrateDeferred = async (pendingRoot) => {
      if (!pendingRoot || pendingRoot.dataset.relatedLoading === 'true') return;
      pendingRoot.dataset.relatedLoading = 'true';

      const sectionId = pendingRoot.dataset.sectionId;
      if (!sectionId) {
        removePendingSection(pendingRoot);
        return;
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sectionId);
        const response = await fetch(url.pathname + url.search);
        if (!response.ok) throw new Error('Related products section failed');

        const data = await response.json();
        const html = sectionHtmlFromPayload(data, sectionId);
        if (!html) {
          removePendingSection(pendingRoot);
          return;
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection =
          doc.querySelector(`#shopify-section-${CSS.escape(sectionId)}`) ||
          doc.body.firstElementChild;
        const relatedRoot = newSection?.querySelector('[data-related-products]');

        if (!newSection || !relatedRoot) {
          removePendingSection(pendingRoot);
          return;
        }

        const currentSection = pendingRoot.closest('.shopify-section');
        if (currentSection) {
          currentSection.replaceWith(newSection);
        } else {
          pendingRoot.replaceWith(newSection);
        }

        initCarousel(relatedRoot);
      } catch (_) {
        removePendingSection(pendingRoot);
      }
    };

    const observeDeferred = (pendingRoot) => {
      if (!pendingRoot) return;

      if (!('IntersectionObserver' in window)) {
        hydrateDeferred(pendingRoot);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          hydrateDeferred(pendingRoot);
        },
        { rootMargin: '1200px 0px', threshold: 0.01 }
      );

      observer.observe(pendingRoot);
    };

    document.querySelectorAll('[data-related-products]').forEach(initCarousel);
    document.querySelectorAll('[data-related-defer]').forEach(observeDeferred);

    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target;
      if (!(container instanceof Element)) return;
      container.querySelectorAll('[data-related-products]').forEach(initCarousel);
      container.querySelectorAll('[data-related-defer]').forEach(observeDeferred);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
